/**
 * 基础的地图组件，初始化地图，但不做任何具体业务，由AppMap.vue组件调用一次
 */
import * as mapvgl from 'mapvgl'
import yanmouStyle from './map.style.yanmou.js'
import loadBMapGL from '@/common/BMapGL.js'

import geoChangfeng from './geo-changfeng.js'


export const mixins = {
  data() {
    return {
      map: null,
      view: null,
    }
  },
  mounted() {
    loadBMapGL().then((BMapGL) => {
      console.log('BMapGL=', BMapGL);
      this.map = new BMapGL.Map('tool-map', {
        minZoom: 10.8,
        maxZoom: 18.8,
        style: {
          styleJson: yanmouStyle
        }
      })
      const {
        map
      } = this
      map.enableScrollWheelZoom()
      map.centerAndZoom(new BMapGL.Point(117.18, 32.12), this.defaultZoom)

      this.view = new mapvgl.View({
        map: map,
      })


      // 乡镇轮廓
      const townsLyr = new mapvgl.PolygonLayer({
        fillColor: 'rgba(111, 160, 191, 0.5)', // 填充颜色
        lineColor: '#6fa0bf',
        lineWidth: 2,
        lineJoin: 'miter',
        enablePicked: true, // 是否可以拾取
        selectedIndex: -1, // 选中项
        selectedColor: 'rgba(111, 160, 191, 0.8)', // 选中项颜色
        autoSelect: true, // 根据鼠标位置来自动设置选中项
        // onClick: (e) => {
        //   if (e && e.dataItem)
        //     vue.$router.push(`/industry/${e.dataItem.properties.Code}`)
        // }
      })
      this.view.addLayer(townsLyr)
      townsLyr.setData(geoChangfeng.features)

    })
  },
}



// WEBPACK FOOTER //
// ./src/components/map-tools/index-mixin.js